import { t } from '@/i18n';

/**
 * The app lockup: a plectrum holding a guitar silhouette.
 *
 * Drawn rather than imported so it stays crisp at any size and inherits the
 * accent token — the icon and the primary action are always the same orange.
 */
export function BrandMark() {
  return (
    <div className="brand">
      <svg className="brand__mark" viewBox="0 0 40 44" width="34" height="37" aria-hidden="true">
        <path
          d="M20 1c9 0 17 4 18 11 1 8-6 20-13 28-3 3-7 3-10 0C8 32 1 20 2 12 3 5 11 1 20 1z"
          fill="var(--accent)"
        />
        <g fill="#fff">
          <path d="M17 30c-3.3 0-6-2.3-6-5.2 0-2 1.2-3.4 2.9-4.2l7.4-7.4 1.7 1.7-7.4 7.4c.8 1.7 1.5 2.9 1.5 4.5 0 1.7-.1 3.2-.1 3.2z" />
          <circle cx="15.5" cy="26" r="3.2" fill="var(--accent)" />
          <rect x="22.5" y="9.5" width="8.5" height="2.2" rx="1.1" transform="rotate(-45 22.5 9.5)" />
        </g>
      </svg>
      <span className="brand__name">{t('app.name')}</span>
    </div>
  );
}
